<style lang="less">

</style>
<template>
  <div class="dcRule">
    <div class="dcRule__title">活动说明</div>
    <div class="dcRule__cont">
      <dl>
        <dt>1. 发起赠送</dt>
        <dd>点击【立即赠送】，分享给好友。</dd>
      </dl>
      <dl>
        <dt>2. 好友领取</dt>
        <dd>
          好友通过链接登录，如果好友是新用户，则领取成功，否则领取失败。好友可以分享给其他人领取，赠送人也可以重新赠给其他好友。
        </dd>
      </dl>
      <dl>
        <dt>3. 权限开通</dt>
        <dd>
          当天领取，第二个工作日会统一开通权限。用户在点击【我的软件】前往下载软件进行使用。
        </dd>
      </dl>
    </div>
  </div>
</template>
<script>
export default {}
</script>
